<template>
  <BoardView id="ArticlesAdd" :title="article.title || $t('title')">
    <FormArticleJoint
      :article.sync="article"
      :isSaving="isSaving"
      @save="create" />
  </BoardView>
</template>

<script>
import BoardAdd from '@mixins/BoardAdd'
import FormArticleJoint from '@forms/FormArticleJoint'

export default {
  mixins: [
    BoardAdd('article', {
      factory: () => ({
        laptops: [],
        specs: [],
      }),
      redirectTo: (_, recordCreated) => ({
        name: 'Article',
        params: {
          id: recordCreated.id,
        },
      }),
    }),
  ],
  components: {
    FormArticleJoint,
  },
}
</script>

<style lang="scss">
#ArticlesAdd {
  .BoardView-title {
    text-align: center;
  }
}
</style>

<i18n>
{
  "en": {
    "title": "New Article"
  }
}
</i18n>
